import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { batch, useDispatch, useSelector } from 'react-redux';

import { permissions } from '../../../common/permissionGroup';
import Breadcrumbs from '../../../layout/components/Breadcrumbs';
import PermissionsGate from '../../../components/PermissionsGate/PermissionsGate';
import Button from '../../../components/Button/Button';
import ButtonTypes from '../../../constants/buttonTypes';
import { IconPlus } from '../../../assets/icon';
import CustomSelect from '../../../components/Select/CustomSelect';
import { articleMarketplacesList } from '../../../constants/articleMarketplaces';
import { articleStatusList } from '../../../constants/articleStatus';
import SearchInput from '../../../components/SearchInput/SearchInput';
import { setArticlesFilter } from '../../../actions/articles/articlesFilter';
import getArticles from '../../../thunks/articles/getArticles';
import Pagination from '../../../components/Pagination/Pagination';
import routes from '../../../router/routes';

const subheaderClassName = 'flex items-center border-t border-[#eff2f5] dark:border-[#1b263b] px-[25px] h-full';
const breadcrumbsClassName = 'py-[5px]';
const searchContainerClassName = 'ml-[20px] w-full max-w-[400px]';
const searchInputClassName = 'py-[10px]';
const selectStatusClassName = 'mr-[20px] w-full';
const selectMarketClassName = 'min-w-[160px]';
const dividerClassName = 'w-[1px] bg-[#eff2f5] dark:bg-[#1b263b] mx-[17px]';
const buttonClassName = 'px-[13px] py-[8px] mr-[5px]';

const ArticlesSubheader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [timer, setTimer] = useState();
  const {
    query,
    getArticles: {
      size,
      lastPage,
      currentPage
    }
  } = useSelector((state) => ({
    query: state?.articlesFilter?.query,
    getArticles: state?.getArticles
  }));

  useEffect(() => {
    clearTimeout(timer);
    const t = setTimeout(() => batch(() => {
      dispatch(setArticlesFilter({ page: 1 }));
      dispatch(getArticles());
    }), 800);
    setTimer(t);
  }, [query]);

  const breadcrumbs = {
    pageTitle: 'Articles',
    history: [
      {
        title: 'Home',
        onClick: () => navigate('/')
      },
      {
        title: 'Articles',
      },
    ]
  };

  const onSearch = ({ target: { value } }) => dispatch(setArticlesFilter({ query: value, page: 1 }));

  const onCreateNew = () => navigate(routes.ARTICLES_NEW);

  const onSelectMarket = (data) => {
    const { value } = data || {};
    batch(() => {
      dispatch(setArticlesFilter({
        ...(value ? { articlesMarket: [value] } : { articlesMarket: [] }),
        page: 1
      }));
      dispatch(getArticles());
    });
  };

  const onSelectStatus = (data) => {
    const { value } = data || {};
    batch(() => {
      dispatch(setArticlesFilter({
        ...(value ? { articlesStatus: [value] } : { articlesStatus: [] }),
        page: 1
      }));
      dispatch(getArticles());
    });
  };

  const onPagePress = (page) => batch(() => {
    dispatch(setArticlesFilter({ page }));
    dispatch(getArticles());
  });

  return (
    <div className={subheaderClassName}>
      <div className="flex-1">
        <div className="flex flex-row items-center">
          <Breadcrumbs breadcrumbs={breadcrumbs} containerStyle={breadcrumbsClassName} />
          <div className="flex flex-row flex-1">
            <div className={searchContainerClassName}>
              <SearchInput styleInput={searchInputClassName} onChange={onSearch} value={query} />
            </div>
          </div>
          <div className="flex flex-1">
            <div className="flex justify-center">
              <Pagination
                currentPage={currentPage}
                onPagePress={onPagePress}
                lastPage={lastPage}
                size={size}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-end">
        <div className={selectStatusClassName}>
          <CustomSelect
            options={articleStatusList}
            isSearchable={false}
            placeholder="Status"
            onChange={onSelectStatus}
            isClearable
          />
        </div>
        <div className={selectMarketClassName}>
          <CustomSelect
            options={articleMarketplacesList}
            isSearchable={false}
            placeholder="Marketplace"
            onChange={onSelectMarket}
            isClearable
          />
        </div>
        <div className={dividerClassName} />
        <PermissionsGate can={permissions.ARTICLES_CREATE}>
          <Button
            type={ButtonTypes.LIGHT_SUCCESS}
            icon={<IconPlus />}
            onClick={onCreateNew}
            containerStyle={buttonClassName}
          />
        </PermissionsGate>
      </div>
    </div>
  );
};

ArticlesSubheader.propTypes = {};

ArticlesSubheader.defaultProps = {};

export default ArticlesSubheader;
